import { IAdminLogConfirmOk, IAdminLogsToConfirm, ILogPub } from "@api/admin.int";
import { Box, BoxProps, Button, Heading, Stack, useBoolean } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { DeepErrorBox } from "components/misc";
import { HitBogyo, HitBox, HitLineMain, HitLineSub, HitRight, PaginatorBox, usePaginator } from "components/paginator";
import { useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { useVVNav } from "components/vvNav";
import { log } from "console";
import { NavMainLink } from "features/NavMain";
import React, { createContext, useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router";
import { NYIL_BTN } from "theme";

export interface IAdminOption {
	title: string;
	action: () => void;
}

export interface IAdminContext {
	isAdmin: boolean;
	options: IAdminOption[];
}

export const AdminContext = createContext<IAdminContext>({
	isAdmin: false,
	options: [],

})


export function AdminLayout() {
	return <Outlet />

}

type TPage = IAdminLogsToConfirm['response']['payload'];


export function AdminLogsToConfirm() {
	//const nav = useNavigate();
	const nav = useVVNav();
	const navBack = '/map';
	const isDetailed = false;

	const api = useVVApi();
	const [selected, setSelected] = useState<ILogPub>();

	const paginator = usePaginator({
		parse: (p: TPage) => ({ items: p.logs, nextKeys: p.nextKeys }),
		deps: [],
		loadNext: async (fromKeys?: string) => await api.fetch<IAdminLogsToConfirm>({
			url: '/admin/logs/to-confirm', method: 'GET', query: { ...fromKeys && { fromKeys } }
		}),

	});

	const adminCtx = useMemo<IAdminContext>(() => ({
		isAdmin: true,
		options: [{
			title: "Jóváhagyom",
			action: () => alert("Hello")
		}]
	}), []);

	const itemClick = (logItem: ILogPub) => {
		console.log(logItem);
		setSelected(logItem);
		if (logItem.info?.affairKey)
			nav.toDetail('/affair/' + logItem.info?.affairKey);
		else
			nav.toRoot();
	}


	const onConfirmOK = async (logItem: ILogPub) => {
		paginator.setError('');
		paginator.setIsLoading(true);
		try {
			await api.fetch<IAdminLogConfirmOk>({
				url: '/admin/logs/to-confirm/ok', method: 'POST',
				payload: { logPk: (logItem as any).pk, logSk: (logItem as any).sk }
			});
			const ix = paginator.page!.logs.indexOf(logItem);
			paginator.updatePage({...paginator.page, logs: paginator.page!.logs.filter(i => i !== logItem)});
			const nextItem = paginator.page!.logs[ix];
			if (nextItem) {
				itemClick(nextItem);
			}
		} catch (ex) {
			paginator.setError('' + ex);
		} finally {
			paginator.setIsLoading(false);
		}
	}


	return <><VizvMainCol
		isTool={{ width: 400, isDetailed }} mapNavRoot={'/admin/logs-to-confirm'}
	>
		<VizvCard
			isTool
			{...navBack && { onBack: () => nav.toRoot() }}
			isClosable
			mr={5} mt={5}
			maxHeight="calc(100vh - 4em)"
			flex="1"
		>
			<VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2}
			//{...parent && { mt: 0 }}
			>
				Jóváhagyás
			</VizvCardHeaderPopup>

			<PaginatorBox pager={paginator} item={log => <HitBox hit={log} onClick={() => itemClick(log)}>
				<HitRight >
					<HitLineSub>{log.user.userName}&nbsp;/&nbsp;{formatDateTime(log.createdAt)}</HitLineSub>
					{log.info?.affairTitle
						? <>
							<HitLineMain>{log.info?.affairTitle}</HitLineMain>
							<HitLineSub>{log.logAction}</HitLineSub>
						</>
						: <>
							<HitLineMain>{log.logAction}</HitLineMain>
						</>}
					{log === selected && <Box display='flex' flexDir='row' justifyContent='flex-end'>
						<Button colorScheme="green" size='xs' onClick={() => onConfirmOK(log)}>Jóváhagyom</Button>
					</Box>}
				</HitRight>
			</HitBox>} />

			{/* 
			{logs.length===0 && <Box>Nincs jóváhagyásra váró esemény...</Box>}
			<Stack p={2} pb={4} gap={2} >
				{logs.map((log, lix) => <Box key={lix} onClick={() => itemClick(log)}
					_hover={{ bg: '#000' }}
					{...log === selected && { bg: '#333' }}

				>
					{(log as any).info && (log as any).info.affairKey ? <NavMainLink
						to={`/admin/logs-to-confirm/affair/${(log as any).info.affairKey}`}
					>{log.logAction}</NavMainLink>
						: <NavMainLink
							to={`/admin/logs-to-confirm`}
						>{log.logAction}</NavMainLink>
					}
					<Box fontSize='xs' lineHeight='normal'>
						{log.user && <Box>{log.user.userName}</Box>}
						{log.createdAt && <Box>{formatDateTime(log.createdAt)}</Box>}
					</Box>
					{log === selected && <Box>
						<Button colorScheme="green" size='xs' onClick={() => onConfirmOK(log)}>Jóváhagyom</Button>
					</Box>}
				</Box>)}
			</Stack>
			*/}
		</VizvCard>
	</VizvMainCol>
		<AdminContext.Provider value={adminCtx}>
			<Outlet />
		</AdminContext.Provider>
	</>
}

export interface AdminLogsToConfirmItemProps {
	logItem: ILogPub;
	isSelected: boolean;
	onClick: (v: ILogPub) => void
	onConfirmOK: (v: ILogPub) => void
}

export function AdminLogsToConfirmItem({ logItem, isSelected, onClick, onConfirmOK }: AdminLogsToConfirmItemProps) {
	switch (logItem.logAction) {
		case 'affair-create':
			const li = logItem as any;
			if (!li.info || !li.info.affairKey)
				return <Box color='red'>{logItem.logAction} : no affair key</Box>;
			return <AdminNavLink isSelected={isSelected} onClick={() => onClick(logItem)}
				to={`/admin/logs-to-confirm/affair/${(logItem as any).info.affairKey}`}
				actions={<>
					<Button colorScheme="green" size='xs' onClick={() => onConfirmOK(logItem)}>Jóváhagyom</Button>
				</>}
			>
				{logItem.logAction} {logItem.user.userName}
			</AdminNavLink>
		default:
			return <Box color='red'>{logItem.logAction}</Box>
	}
}

export interface AdminNavLinkProps extends BoxProps {
	isSelected: boolean;
	to?: string;
	actions?: React.ReactNode;
}

export function AdminNavLink({ children, isSelected, onClick: pOnClick, to, actions, ...rest }: AdminNavLinkProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);

	const onClick = (e: React.MouseEvent<any>) => {
		if (pOnClick) {
			if (!to)
				e.preventDefault();
			pOnClick(e);
		} else {
			if (isMobile)
				setLayoutPush('menu');
		}
	}

	//const isActive = location.pathname === to;

	return <Box>
		<NavLink to={to || ''}
			onClick={onClick}
		><Heading
			position='relative' left={0}
			display='flex' flexDir='row' alignItems='center' gap={1}
			background='#fff1'
			color='#d2ddd9'

			{...isMobile ? { fontWeight: '400', fontSize: 'lg' } : { fontWeight: '400', fontSize: 'md' }}

			p={2}
			_hover={{ textDecor: 'none', left: '0.2em', background: '#fff2', color: '#fff' }}
			{...isSelected && {
				background: 'secondary.main', color: '#000', fontWeight: 500, left: '1em',
				_hover: { left: '1.2em' }
			}}
			transition={`background-color .15s ease-out, color .15s ease-out, left .15s ease-out`}
			{...rest}


		>{children}
				<Box ml='auto' w='18px'>{isSelected && <Box as='span' fontFamily='initial' >{NYIL_BTN}</Box>}</Box>
			</Heading>
		</NavLink>
		{actions && isSelected && <Box display='flex' flexDir='row' alignItems='center' justifyContent='space-evenly' mt={2}>
			{actions}
		</Box>}
	</Box>
}


